import React, { Component, Fragment, compose } from "react";
import { connect } from "react-redux";
import createBemClass from "react-bem-builder";
import { map, reverse, slice, find } from "lodash";
import { Row, Col, Grid } from "../components/layout";
import {
  Header,
  LocationInfoGroup,
  Section,
  Link,
  Project,
  Slider
} from "../components";
import Fade from "react-reveal/Fade";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { cssTransitionClasses } from "../transitions/utilities/transition-utility";
import LinkWithArrow from "../components/link-with-arrow";

const headerBlock = createBemClass("home-header");
const projectsBlock = createBemClass("home-section-projects");
const contentBlock = createBemClass("home-section-content");

class HomeContainer extends Component {
  state = {
    activeIndex: 0
  };

  render() {
    return (
      <Fragment>
        {this.renderHeader()}
        <TransitionGroup component={null}>
          <CSSTransition
            key={"home-page-content"}
            classNames={cssTransitionClasses("home-page-content")}
            appear={true}
            timeout={350}
          >
            <div>{this.renderProjectCarouselSection()}</div>
          </CSSTransition>
        </TransitionGroup>
        {this.props.content.map(section => {
          if (section.id === "services") {
            return this.renderServicesSection(section);
          }
          return (
            <Fade delay={200}>
              <Grid className={contentBlock()}>
                <Row>
                  <Col md={6}>
                    <h2 className={contentBlock("title")}>{section.title}</h2>
                  </Col>
                  <Col md={6}>
                    {section.content &&
                      section.content.map((line, index) => (
                        <p className={contentBlock("copy")}>{line}</p>
                      ))}
                    {section.cta &&
                      section.cta.text.map(line => (
                        <p className={contentBlock("cta")}>{line}</p>
                      ))}
                    {section.cta && (
                      <LinkWithArrow
                        to="/contact-us"
                        className={contentBlock("link")}
                      >
                        {section.cta.linkText}
                      </LinkWithArrow>
                    )}
                  </Col>
                </Row>
              </Grid>
            </Fade>
          );
        })}
      </Fragment>
    );
  }

  renderHeader() {
    return (
      <Header className={headerBlock()} dark noTopSpacing>
        <TransitionGroup component={null}>
          <CSSTransition
            key={"home-header"}
            classNames={cssTransitionClasses(headerBlock("content"))}
            appear={true}
            timeout={350}
          >
            <div className={headerBlock("content")}>
              <h1 className={headerBlock("heading")}>
                Beautiful design.
                <br />
                Precise engineering.
                <br />
              </h1>
              <div className={headerBlock("bottom")}>
                <LocationInfoGroup
                  primary="London"
                  secondary="letsmake@kingstreetapps.com"
                  timezone="Europe/London"
                  className={headerBlock("location-info-group")}
                />
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Header>
    );
  }

  renderProjectCarouselSection() {
    const settings = {
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 10000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: projectsBlock("thumbs"),
      customPaging: function(i) {
        return (
          <a>
            <img src={thumbs[i]} />
          </a>
        );
      }
    };
    const reversedProjects = reverse(slice(this.props.projects));
    const thumbs = reversedProjects.map(proj => proj.homepage_image.url);
    return (
      <Section className={projectsBlock()}>
        <Fade delay={200}>
          <Slider {...settings} modifier="project" thumbs={thumbs}>
            {map(reversedProjects, (project, index) => (
              <Project
                key={index}
                project={project}
                withFade={false}
                homeCarousel
                altImage
              />
            ))}
          </Slider>
        </Fade>
      </Section>
    );
  }

  renderServicesSection(section) {
    return (
      <Fade delay={200}>
        <Grid className={contentBlock()}>
          <Row>
            <Col xs={12}>
              <h2 className={contentBlock("title")}>{section.title}</h2>
            </Col>
            <Col xs={12} md={6} className={contentBlock("accordion")}>
              {section.accordionContent.map((accordionItem, index) => (
                <div
                  className={contentBlock(
                    "accordion-item",
                    index === this.state.activeIndex ? "active" : "null"
                  )}
                  onClick={() => this.setState({ activeIndex: index })}
                >
                  <div>
                    <span className={contentBlock("accordion-item__title")}>
                      <h3
                        className={contentBlock("accordion-item__title__text")}
                      >
                        {accordionItem.title}
                      </h3>
                      <b className={contentBlock("accordion-item__title")}>
                        {index === this.state.activeIndex ? "–" : "+"}
                      </b>
                    </span>
                    {accordionItem.content.map(item => (
                      <p>{item}</p>
                    ))}
                  </div>
                </div>
              ))}
            </Col>
            <Col xs={12} md={6}>
              <img
                style={{ width: "100%" }}
                src={section.accordionContent[this.state.activeIndex].image}
              />
            </Col>
            <Col xs={12} md={6}>
              {section.content &&
                section.content.map((line, index) => (
                  <p className={contentBlock("copy")}>{line}</p>
                ))}
              {section.cta &&
                section.cta.text.map(line => (
                  <p className={contentBlock("cta")}>{line}</p>
                ))}
              {section.cta && (
                <LinkWithArrow
                  to="/contact-us"
                  className={contentBlock("link")}
                >
                  {section.cta.linkText}
                </LinkWithArrow>
              )}
            </Col>
          </Row>
        </Grid>
      </Fade>
    );
  }
}

const mapStateToProps = state => {
  return {
    content: [...state.homePage],
    projects: [
      {
        ...find(state.internalProjects, { id: "shaolinq" }),
        introduction: "Our powerful ORM and LINQ provider for C# and .NET"
      },
      ...state.externalProjects
    ]
  };
};

export default connect(mapStateToProps)(HomeContainer);
